import * as React from "react";
import { Button, Message } from "semantic-ui-react";

interface IProps {
}

interface IState {
}

class NotFound extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <div>

        <Message negative>
          <Message.Header>Not Found</Message.Header>
          <p>指定されたページが見つかりません</p>
        </Message>

        <div className='ui center aligned grid' style={{ marginTop: 10 }}>
          <Button basic color='black' content='トップページへ戻る' href='/' />
        </div>

      </div>
    );
  };

}
export default NotFound;
